// Bridge from the business API layer to the shell for period locking, the
// same shape as businessReadOnlyNotifier: parseEnvelope reports every 422
// `period_locked` response here and the shell refreshes the cached close
// status, so an affordance the UI failed to gate self-corrects rather than
// staying wrong until the next reload.
//
// The closing date travels with the notification because it is the one thing
// the client cannot derive — the row's own date and the attempted action are
// already known where the failure happened.

export interface PeriodLockNotice {
  closedThrough: string | null;
  message: string;
}

type Listener = (notice: PeriodLockNotice) => void;

const THROTTLE_MS = 5000;

let listeners = new Set<Listener>();
let lastNotifiedAt = 0;

/** Subscribe to period-lock rejections; returns the unsubscribe function. */
export function subscribeBusinessPeriodLock(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Called by the API layer on a 422 period_locked response. */
export function notifyBusinessPeriodLock(notice: PeriodLockNotice): void {
  const now = Date.now();
  if (now - lastNotifiedAt < THROTTLE_MS) return;
  lastNotifiedAt = now;
  listeners.forEach(listener => listener(notice));
}

/** Test hook — clears listeners and the throttle window. */
export function resetBusinessPeriodLockNotifier(): void {
  listeners = new Set();
  lastNotifiedAt = 0;
}
